import i18n from '../plugins/language/index';
export default {
    // "altitude": "轿厢高度",
    "fault_no": i18n.tc('l.fault_no'),
    "door_circuit": i18n.tc('l.door_lock_loop'),
    "door_circuit1": i18n.tc('l.door_lock_loop1'),
    "scram_circuit": i18n.tc('l.scram_loop'),
    "scram_circuit1": i18n.tc('l.scram_loop1'),
    "door_area":i18n.tc('l.door_area'),
    "door_area1":i18n.tc('l.door_area1'),
    "door_area2":i18n.tc('l.door_area2'),
    "converter_fault":i18n.tc('l.converter_fault'),
    "KMC":i18n.tc('l.KMC'),
    "KDY":i18n.tc('l.KDY'),
    "opend_brake":i18n.tc('l.opend_brake'),
    "inverter_run":i18n.tc('l.inverter_run'),
    "inverter_enable":i18n.tc('l.inverter_enable'),
    "KMC_output":i18n.tc('l.KMC_output'),
    "KDY_output":i18n.tc('l.KDY_output'),
    "door_area_up": i18n.tc('l.door_area_up'),
    "door_area_down": i18n.tc('l.door_area_down'),
    "station_broadcast":i18n.tc('l.station_broadcast') ,
    "run_down": i18n.tc('l.run_down'),
    "run_up": i18n.tc('l.run_up'),
    "running": i18n.tc('l.running'),
    "running1": i18n.tc('l.running1'),
    "front_door_opened": i18n.tc('l.front_door_opened'),
    "front_door_opening": i18n.tc('l.front_door_opening'),
    "front_door_closed": i18n.tc('l.front_door_closed'),
    "front_door_closing": i18n.tc('l.front_door_closing'),
    "front_light_curtains": i18n.tc('l.front_light_curtains'),
    "front_touch_board": i18n.tc('l.front_touch_board'),
    "back_door_opened": i18n.tc('l.back_door_opened'),
    "back_door_opening": i18n.tc('l.back_door_opening'),
    "back_door_closed": i18n.tc('l.back_door_closed'),
    "back_door_closing": i18n.tc('l.back_door_closing'),
    "back_light_curtains": i18n.tc('l.back_light_curtains'),
    "back_touch_board": i18n.tc('l.back_touch_board'),
    "load_less": i18n.tc('l.load_less'),
    "load_more": i18n.tc('l.load_more'),
    "load_full": i18n.tc('l.load_full'),
    "load_over": i18n.tc('l.load_over'),
    "control_multiple": i18n.tc('l.control_multiple'),
    "control_double": i18n.tc('l.control_double'),
    "endpoint_secondary_up": i18n.tc('l.endpoint_secondary_up'),
    "endpoint_secondary_down": i18n.tc('l.endpoint_secondary_down'),
    "endpoint_up": i18n.tc('l.endpoint_up'),
    "endpoint_down": i18n.tc('l.endpoint_down'),
    "limit_up": i18n.tc('l.limit_up'),
    "limit_down": i18n.tc('l.limit_down'),
    "run_status": i18n.tc('l.run_status'), //  1-自动， 2-检修， 3-司机， 4-专用， 5-消防， 6-锁梯， 7-VIP， 8-故障
    // "run_model":"", //0-正常  1-停电应急（新） 2 - 地震（新）3-消防（新） 4-消防初态（新） 5-专用  6-司机 7-VIP
    "floor_total": i18n.tc('l.total_floor'), //（门区隔板数量）
    "floor_current": i18n.tc('l.floor_current'), //（绝对，最底层为1）
    "running_interval": i18n.tc('l.running_interval'), // 0-停止， 1-加速， 2-稳速， 3-制动， 4-爬行， 5-维持零速
    "zero_speed":i18n.tc('l.zero_speed'),
    "change_speed_mark":i18n.tc('l.change_speed_mark'),
    "curve_change_speed":i18n.tc('l.curve_change_speed'),
    "change_direction_openid":i18n.tc('l.change_direction_openid'),
    "running_speed": i18n.tc('l.running_speed'), //（m/s）
    // "month_energy": "月平均能耗", //（kwh）
    // "weight_percent": "称重百分数", //  0~125%
    // "someone_has":"有人",
    // "total_control":"总控",
    // "CAN_fault":"can故障",
    // "remote_stop":"远程停梯状态反馈",
    // "floor_selected": "内选楼层", // [1,2,3],    // 内选
    // "floor_up_selected": "上行外呼楼层",//[4,5],   // 外呼上行
    // "floor_down_selected": "下行外呼楼层",   //[6,7]  // 外呼下行
}